export const meta = {
  title: "Ein Foodie-Guide für authentische Schweizer Küche im Berner Oberland",
  description: "Jenseits von Fondue und Schokolade: Entdecken Sie die Farm-to-Table Philosophie im Restaurant Jungfrau.",
  date: "2024-03-01",
  image: "/images/main_restaurant.png",
  author: "Beatenberg Culinary Team",
  category: "Dining",
  keywords: ["Schweizer Küche", "Restaurant Thunersee", "Restaurant Jungfrau", "Farm to Table"]
}

# Ein Foodie-Guide für authentische Schweizer Küche im Berner Oberland

Die Schweizer Küche wird oft auf Käse und Schokolade reduziert. Doch die kulinarische Landschaft des Berner Oberlandes ist weitaus reicher. Im **Restaurant Jungfrau** verfechten wir einen "Farm-to-Table"-Ansatz.

## Der Unterschied beim Alpkäse
Nicht jeder Käse ist gleich. *Alpkäse* kann nur in den Sommermonaten hergestellt werden, wenn die Kühe auf hochgelegenen Weiden grasen.

*Inhalt wird bald erweitert...*

[Tisch reservieren](/de/dining)
